import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { PaymentForm } from "../paymentForm";

const stripePromise = loadStripe("pk_test_51H4M4QJotmxVmolNEob2ze8Hfa2TPhK39kH71ji5KBaoZjFBoekC2hzVJ2EsCfkA24RpAkz71QpnY5SvA1pJM2qR00pbcHm3om");

interface IStripeContainerProps {
	onSavePaymentMethod: (token: string) => void;
	onClosePaymentMethod: () => void;
	hiddenButtons?: boolean;
}

export const StripeContainer = (props: IStripeContainerProps) => {
	return (
		<Elements stripe={stripePromise}>
			<PaymentForm
				onSavePaymentMethod={props.onSavePaymentMethod}
				onClosePaymentMethod={props.onClosePaymentMethod}
				hiddenButtons={props.hiddenButtons}
			/>
		</Elements>
	)
};
